module.exports = __webpack_public_path__ + "static/media/10k.e95b1b9a.jpg";